import * as Sentry from '@sentry/react'
import { toast } from 'sonner'
import { isCreditRefusal } from '@/lib/upgrade-toast'

interface ReportErrorOptions {
  toast?: boolean | string
}

export function reportError(
  error: Error | string | unknown,
  options: ReportErrorOptions = {}
) {
  // Running out of credits is a state, not a failure, and it was already
  // shown (the plans dialog): no Sentry event, no error toast on top.
  if (isCreditRefusal(error)) {
    return
  }
  const errorObj =
    error instanceof Error ? error : new Error(String(error), { cause: error })

  // Report to Sentry
  Sentry.captureException(errorObj)

  // Show toast if requested
  if (options.toast !== false) {
    const message =
      typeof options.toast === 'string'
        ? options.toast // Explicit custom message
        : errorObj.message // Use error's message

    toast.error(message)
  }
}

/**
 * Report something noteworthy that isn't a failure — a degraded-but-valid
 * outcome worth telemetry. Goes to Sentry at `warning` level so it stays out of
 * the error rate, and never toasts: the UI surfaces these in place, where the
 * user has the context to act on them.
 */
export function reportWarning(
  message: string,
  context?: Record<string, unknown>
) {
  Sentry.captureMessage(message, { level: 'warning', extra: context })
}
